import { render, staticRenderFns } from "./Due.vue?vue&type=template&id=1837d56f&"
import script from "./Due.vue?vue&type=script&lang=ts&"
export * from "./Due.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports